module.exports = __webpack_public_path__ + "img/question-black.133974a0.svg";